import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import isEmptyObject from '@utils/isEmptyObject';
import { updateEducatorLevelInfo } from '@actions/educator';
import useLevelDisplayInfo from '@api/hooks/profile/useLevelDisplayInfo';
import Dynamic from '@base/Dynamic/Dynamic';
import { PARTNER_EDUCATOR_CONFIG } from './constants';

const FaqLevels = Dynamic(() =>
  import('@educator/LevelsAndLeaderboard/FaqLevels')
);

const EducatorTag = styled.div`
  display: flex;
  align-items: center;
  cursor: ${({ $isPartnerEducator }) =>
    $isPartnerEducator ? 'initial' : 'pointer'};
`;

const StyledH6 = styled(H6)`
  margin-bottom: ${Spacings.SPACING_3B};
  max-height: 100px;
  opacity: 1;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    margin-top: ${Spacings.SPACING_1B};
  }
`;

const EducatorLevelTag = ({ levelInfo, isPartnerEducator }) => {
  const dispatch = useDispatch();
  const [showLevelsFaq, setShowLevelsFaq] = useState(false);
  const { levelsDisplayInfo = [] } = useLevelDisplayInfo();

  let currentLevelDisplayInfo = levelsDisplayInfo?.find((levelDisplayInfo) => {
    return levelDisplayInfo.levelId === levelInfo?.currentLevelId;
  });

  currentLevelDisplayInfo = isPartnerEducator
    ? PARTNER_EDUCATOR_CONFIG
    : currentLevelDisplayInfo;

  useEffect(() => {
    if (!isEmptyObject(levelInfo)) dispatch(updateEducatorLevelInfo(levelInfo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelInfo]);

  if (
    (isEmptyObject(levelInfo) || !currentLevelDisplayInfo) &&
    !isPartnerEducator
  ) {
    return null;
  }

  const openFaqScreen = () => {
    if (isPartnerEducator) return;
    setShowLevelsFaq(true);
  };

  const closeFaqScreen = () => {
    setShowLevelsFaq(false);
  };

  return (
    <>
      <EducatorTag
        onClick={openFaqScreen}
        $isPartnerEducator={isPartnerEducator}
      >
        <StyledH6 color={currentLevelDisplayInfo?.color.primary}>
          {currentLevelDisplayInfo.name}
        </StyledH6>
        <StyledH6 color="var(--color-text-secondary)">
          &nbsp; {levelInfo?.goal?.name ? `in ${levelInfo?.goal?.name}` : ''}
        </StyledH6>
      </EducatorTag>
      {showLevelsFaq && (
        <FaqLevels
          isOpen={showLevelsFaq}
          onClose={closeFaqScreen}
          onPressBack={closeFaqScreen}
          isPublic
        />
      )}
    </>
  );
};

export default EducatorLevelTag;

EducatorLevelTag.propTypes = {
  levelInfo: PropTypes.shape(PropTypes.any)
};

EducatorLevelTag.defaultProps = {
  levelInfo: {}
};
